export default __webpack_public_path__ + "static/media/5.36eb599b.png";